/** Aligns with dashboard API: api/dashboard/DashPermissions */

/** Default privilege keys when none stored (aligned with backend). */
export const DEFAULT_SYSTEM_PAGE_ACTIONS: string[] = [
  'Read',
  'Write',
  'Add',
  'Delete',
  'Launch',
  'Export',
  'Approve',
  'View',
];

/** Row from api/dashboard/DashAuthentication/admin-dashboard-pages (AdminPageDetails catalog). */
export interface AdminDashboardPageRow {
  id: string;
  name: string;
  nameAr?: string;
  category: string;
  categoryAr?: string;
  route: string;
  icon?: string;
  childrens?: string[];
  requiredPermissions?: string[];
  requiredRoles?: string[];
  /** Custom privileges for this page (Read, Write, Add, …). */
  actions?: string[];
  /** UI: joined actions for table cell. */
  actionsLabel?: string;
  /** UI: count of nested routes from Childrens. */
  nestedPathsCount?: number;
}

/** PUT api/dashboard/DashAuthentication/system-pages/{id} */
export interface UpdateSystemPagePayload {
  nameEnglish: string;
  nameArabic?: string;
  categoryEnglish: string;
  categoryArabic?: string;
  route: string;
  icon?: string;
  actions: string[];
}

export interface Permission {
  permissionId: string;
  name: string;
  nameArabic: string;
  parentId: string | null;
  isParent: boolean;
  isChild: boolean;
  userHasAccess: boolean;
  userCanEdit: boolean;
  children: Permission[];
}

export interface UserPermissionsResponse {
  userId: string;
  permissions: Permission[];
}

export interface RolePermissionsResponse {
  roleId: string;
  permissions: Permission[];
}

export interface UpdateUserPermissionsRequest {
  userId: string;
  permissions: Permission[];
}

export interface UpdateRolePermissionsRequest {
  roleId: string;
  permissions: Permission[];
}

/** System catalog grants (api/dashboard/DashPermissions/UserSystemGrants, SaveUserSystemGrants). */
export interface SystemPageGrantDto {
  systemPageId: string;
  actionKeys: string[];
}

export interface UserSystemPageGrantsResponse {
  userId: string;
  grants: SystemPageGrantDto[];
}

export interface UserSystemPageGrantsSaveRequest {
  userId: string;
  grants: SystemPageGrantDto[];
}

export interface RoleSystemPageGrantsResponse {
  roleId: string;
  grants: SystemPageGrantDto[];
}

export interface RoleSystemPageGrantsSaveRequest {
  roleId: string;
  grants: SystemPageGrantDto[];
}

/** Permission catalog DTO (flat / hierarchy). */
export interface PermissionDefinitionDto {
  id: string;
  nameEnglish: string;
  nameArabic: string;
  descriptionEnglish?: string;
  descriptionArabic?: string;
  parentId: string | null;
  children?: PermissionDefinitionDto[];
}

export interface PermissionTreeApiResponse {
  parentPermissions: PermissionDefinitionDto[];
  totalCount: number;
  parentCount: number;
  childCount: number;
}

export interface CreatePermissionPayload {
  parentId?: string | null;
  nameEnglish: string;
  nameArabic?: string;
  descriptionEnglish?: string;
  descriptionArabic?: string;
}

export interface UpdatePermissionPayload {
  nameEnglish?: string;
  nameArabic?: string;
  descriptionEnglish?: string;
  descriptionArabic?: string;
}
